import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {debounceTime, map, skipUntil, startWith, switchMap} from 'rxjs/operators';
import {activityApi} from '@/api/activity';
import {numUtil} from '@/helper/num';
import {fullImageUrlFun} from '@/helper/url';
import {browser$} from '@/streams/browser';

export const query$ = new Subject();

export const kolInfo$ = new BehaviorSubject({
  avatar: '',
  name: '',
});

export const timePeriod$ = new BehaviorSubject({
  riskMonitor: '',
  active: '',
  claim: '',
});

export const bonusCurrency$ = new BehaviorSubject('');

export const bonusStages$ = new BehaviorSubject([]);

export const maxBonus$ = combineLatest([bonusCurrency$, bonusStages$]).pipe(
  debounceTime(100),
  map(([currency, list]) => {
    const val = list.reduce((max, {bonus}) => {
      return Math.max(max, bonus);
    }, 0);
    return `${numUtil.delimit(val)} ${currency}`;
  }, startWith(0))
);

query$
  .pipe(
    skipUntil(browser$),
    switchMap((query) => activityApi.getKolExclusiveActivityInfo(query))
  )
  .subscribe(({data}) => {
    const getImgUrl = fullImageUrlFun();
    if (data) {
      timePeriod$.next({
        riskMonitor: data.extInfo.rewardDays - data.extInfo.depositDays,
        active: data.extInfo.depositDays,
        claim: data.extInfo.rewardOverDays - data.extInfo.rewardDays,
      });
      bonusCurrency$.next(data.currency);
      kolInfo$.next({
        avatar: data.extInfo.photoUri ? getImgUrl(data.extInfo.photoUri) : getImgUrl('7ec0d398bea20b43.png'),
        name: data.extInfo.nickName,
      });
      const bonusStages = data.extInfo.ladderRewardsDTOS.map(({bonusRewards, netDepositAmount, tradeAmount}) => {
        return {
          bonus: bonusRewards,
          trade: tradeAmount,
          deposit: netDepositAmount,
        };
      });
      bonusStages$.next(bonusStages);
      return;
    }
    kolInfo$.next(null);
  });
